import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { List } from '@oliasoft-open-source/react-ui-library';
import { FeatureFlags } from '@oliasoft/feature-flags';
import { getRisks, riskSelected, risksCleanup } from 'store/entities/risks/risks';
import { selectRisksByType } from 'src/store/entities/risks/selectors';
import { RiskType } from 'src/enums/project-modifiers';
import translations from 'src/internationalisation/translation-map.json';
import { withErrorBoundary } from '@oliasoft-open-source/react-ui-library';
import { RisksListByType } from './risks-list-by-type';

const RisksList = ({
  getRisks,
  riskSelected,
  setShowForm,
  setRiskModalVisible,
  setSelectedId,
  onClickAdd,
  projectId,
  risksCleanup,
  isAdding,
  isPageDisabled,
  timeRisksList,
}) => {
  useEffect(() => {
    if (projectId) {
      getRisks(projectId);
    }

    return () => risksCleanup();
  }, [projectId]);

  const isModifierForCostActive = FeatureFlags.isActive('Project Modifier For Cost');

  const { t } = useTranslation();
  const onClickDelete = (id) => {
    setSelectedId(id);
    setRiskModalVisible(true);
    setShowForm(false);
  };
  const onClickItem = (id) => {
    riskSelected(id);
    setShowForm(true);
  };

  const listTitle = isModifierForCostActive
    ? t(translations.projectModifiers_title)
    : `${t(translations.projectModifiers_title)} (${timeRisksList.length})`;

  return (
    <>
      <List
        list={{
          name: <div data-testid="project-modifiers-title">{listTitle}</div>,
          items: [],
          actions: isModifierForCostActive
            ? []
            : [
                {
                  icon: 'add',
                  onClick: () => onClickAdd(RiskType.TIME),
                  disabled: isAdding || isPageDisabled,
                },
              ],
        }}
      />
      <RisksListByType
        type={RiskType.TIME}
        projectId={projectId}
        onClickDelete={onClickDelete}
        onClickItem={onClickItem}
        onClickAdd={() => onClickAdd(RiskType.TIME)}
      />
      {isModifierForCostActive && (
        <RisksListByType
          type={RiskType.COST}
          projectId={projectId}
          onClickDelete={onClickDelete}
          onClickItem={onClickItem}
          onClickAdd={() => onClickAdd(RiskType.COST)}
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  timeRisksList: selectRisksByType(state, RiskType.TIME),
});

const mapDispatchToProps = {
  getRisks,
  riskSelected,
  risksCleanup,
};

const Container = withErrorBoundary(connect(mapStateToProps, mapDispatchToProps)(RisksList));

export { Container as RisksList };
